import React from "react";

export const BackgroundStepNumber = ({ children, styles }) => {
  return (
    <div
      style={{
        fontSize: "10rem",
        opacity: "0.07",
        fontFamily: "elena-web-basic",
        fontWeight: "bold",
        position: "relative",
        top: "0px",
        left: "0px",
        lineHeight: "1",
        // marginTop: "10rem",
        zIndex: 200,
        // marginLeft: "-30%",
        ...styles,
      }}
    >
      {children}
    </div>
  );
};

export default BackgroundStepNumber;
